//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { RIGHTS_STATUS } from '@apis/rights-management/rightsManagementApiModels';
import { getAllSelectedContent } from '@galleries/selectors/bulk-rights-selectors/getAllSelectedContent';
import { ICuralateStore } from '@models/AppState';
import { IRightsRequestState } from '@models/IItemMetadata';
import PartialCuid from '@models/PartialCuid';

export const getIsAllSelectedContentBrandOwned = createSelector(
  getAllSelectedContent,
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.rightsRequestStates,
  (selectedItems, rightsRequestStates) => {
    const onlyBrandOwnedItems = selectedItems
      .map((contentLibraryItem) => {
        const partialCuid = PartialCuid.build(contentLibraryItem);
        return rightsRequestStates[partialCuid];
      })
      .filter(
        (rightsRequestState) =>
          rightsRequestState?.status === RIGHTS_STATUS.BRAND_OWNED,
      );

    return onlyBrandOwnedItems.length === selectedItems.length;
  },
);
